import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

export interface DeleteFollowUpTasksDialogData {
  statusOptions: string[];
}

@Component({
  selector: 'hour4u-admin-delete-followup-tasks-dialog',
  templateUrl: './delete-followup-tasks-dialog.component.html',
  styleUrls: ['./delete-followup-tasks-dialog.component.scss']
})
export class DeleteFollowUpTasksDialogComponent {

  selectedStatuses: string[] = [];

  constructor(
    private dialogRef: MatDialogRef<DeleteFollowUpTasksDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteFollowUpTasksDialogData,
  ) { }

  get isProjectWide(): boolean {
    return this.selectedStatuses.length === 0;
  }

  get confirmLabel(): string {
    return this.isProjectWide
      ? 'Delete for entire project'
      : `Delete for ${this.selectedStatuses.length} outcome${this.selectedStatuses.length === 1 ? '' : 's'}`;
  }

  isSelected(status: string): boolean {
    return this.selectedStatuses.includes(status);
  }

  toggleStatus(status: string): void {
    const index = this.selectedStatuses.indexOf(status);
    if (index >= 0) {
      this.selectedStatuses.splice(index, 1);
    } else {
      this.selectedStatuses.push(status);
    }
  }

  clearSelection(): void {
    this.selectedStatuses = [];
  }

  close(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close(this.selectedStatuses);
  }
}
